export class StatsEntity {
  posts = 0;
  events = 0;
  message = 0;
  group = 0;
  tasks = 0;
}
